import React, { FunctionComponent } from 'react';

import { Title as TitleType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

import BreakpointContainer from '../../BreakpointContainer';

export type TitleProps = {
  standalone?: boolean;
  title?: TitleType;
};

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();
  return {
    root: {
      boxSizing: 'border-box',
      padding: spacing(0, 4),
      [breakpoint.up('md')]: {
        marginTop: spacing(2),
      },
    },
  } as const;
};

const Title: FunctionComponent<TitleProps> = (props) => {
  const { standalone } = props;
  const { title, level = 'h2' } = props.title || {};

  const classes = useStyles();

  if (!title) {
    return null;
  }
  return (
    <Flex justifyContent="center" css={classes.root}>
      <BreakpointContainer maxWidth={standalone ? 'xl' : 'lg'}>
        <Text variant="headline1" as={level}>
          {title}
        </Text>
      </BreakpointContainer>
    </Flex>
  );
};

export default Title;
